import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

// import { getGeneralService } from 'services/checkin';
// import { GeneralData } from 'services/checkin/types';
import { getCampaignsService } from 'services/system';
import { CampaignType } from 'services/system/types';

// ---------------------------------------------------------------------------
// State
// ---------------------------------------------------------------------------

interface SystemState {
  /** true = trình duyệt có kết nối internet */
  isOnline: boolean;
  /**
   * true nếu người dùng đã từng mất mạng trong phiên này.
   * Dùng để hiển thị banner "Kết nối đã được khôi phục".
  */
  wasOffline: boolean;
  // system?: GeneralData;
  loading?: boolean;
  campaignData: CampaignType | null;
}

const initialState: SystemState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  wasOffline: false,
  campaignData: null
};

// export const getSystemAction = createAsyncThunk<GeneralData>(
//   'systemReducer/getSystem',
//   async (_, { rejectWithValue }) => {
//     try {
//       return await getGeneralService();
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   },
// );

export const getCampaignsAction = createAsyncThunk<
  CampaignType,
  undefined
>('system/getCampaignsAction', async (_, { rejectWithValue }) => {
  try {
    const res = await getCampaignsService();
    return res;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------

export const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    /** Gọi khi trình duyệt phát sự kiện `online` */
    setOnline($state) {
      $state.isOnline = true;
    },
    /** Gọi khi trình duyệt phát sự kiện `offline` */
    setOffline($state) {
      $state.isOnline = false;
      $state.wasOffline = true;
    },
    /** Override trực tiếp nếu cần (e.g. init từ navigator.onLine) */
    setNetworkStatus($state, action: PayloadAction<boolean>) {
      if (!action.payload) {
        $state.wasOffline = true;
      }
      $state.isOnline = action.payload;
    },
  },
  extraReducers(builder) {
    // builder.addCase(getSystemAction.pending, ($state) => {
    //   $state.loading = true;
    // });
    // builder.addCase(getSystemAction.fulfilled, ($state, action) => {
    //   $state.system = action.payload;
    //   $state.loading = false;
    // });
    // builder.addCase(getSystemAction.rejected, ($state) => {
    //   $state.loading = false;
    // });
    builder.addCase(getCampaignsAction.fulfilled, ($state, action) => {
      $state.campaignData = action.payload;
    });
  },
});

export const { setOnline, setOffline, setNetworkStatus } = systemSlice.actions;

export default systemSlice.reducer;
